/* eslint-disable no-param-reassign */
export const adjustSizeRemain = (array) => {
  const lotMap = new Map();

  array.forEach((item, index) => {
    const { lot } = item;
    const quantity = Number(item.quantity.replaceAll('.', ''));

    if (lotMap.has(lot)) {
      const previousIndex = lotMap.get(lot);
      const previousItem = array[previousIndex];
      const adjustedSizeRemain = previousItem.size_remain - Number(previousItem.quantity.replaceAll('.', ''));

      if (adjustedSizeRemain >= 0 && (quantity === '' || quantity <= adjustedSizeRemain) && lot) {
        item.size_remain = adjustedSizeRemain;
      }
    }

    lotMap.set(lot, index);

    if (index > 0 && lot === array[index - 1].lot && index === array.length - 1 && quantity > array[index - 1].size_remain) {
      item.size_remain = array[index - 1].size_remain;
    }
  });

  return array;
};
